<template>
  <div class="wrapper d-flex align-items-stretch">
			<nav id="sidebar" class="back-profile-nav">
				<div class="p-4 pt-5">
		  		<img :src="ImgKraudLogo" class="header-desktop" height="40" alt="" />
          <img :src="Group2" class="header-mobile" style="cursor: pointer;" height="40" alt="" />
	        <ul class="list-unstyled components mb-5">
	          <li class="active menu-options">
	            <img :src="assetsImg" alt="" /> <span><a href="#homeSubmenu" class="text-option">Assets Overview</a></span> 
	            <!--ul class="collapse list-unstyled" id="homeSubmenu">
                <li>
                    <a href="#">Home 1</a>
                </li>
                <li>
                    <a href="#">Home 2</a>
                </li>
                <li>
                    <a href="#">Home 3</a>
                </li>
	            </ul-->
	          </li>
	          <li class="menu-options">
              <img :src="marketImg" alt="" /> <span><a href="#" class="text-option">Marketplace</a></span>
	          </li>
            <li class="menu-options">
              <img :src="referImg" alt="" /> <span><a href="#" class="text-option">Refer ad earn</a></span>
	          </li>
            <li class="menu-options">
              <img :src="transImg" alt="" /> <span><a href="#" class="text-option">Transactions</a></span>
	          </li>
            <li class="menu-options">
              <img :src="walletImg" alt="" /> <span><a href="#" class="text-option">wallet</a></span>
	          </li>
            <li class="menu-options">
              <img :src="taxesImg" alt="" /> <span><a href="#" class="text-option">Taxes</a></span>
	          </li>
            <li class="menu-options">
              <img :src="settingsImg" alt="" /> <span><a href="#" class="text-option">settings</a></span>
	          </li>
            <li class="menu-options">
              <img :src="logoutImg" alt="" /> <span><a href="#" class="text-option">Log Out</a></span>
	          </li>
	          
	        </ul>
	      </div>
    	</nav>

        <!-- Page Content  -->
      <div class="content-profile">
        <nav class="navbar back-profile-nav text-white fixed-top">
          <h2 class="mb-4 text-header">Welcome Paula</h2>
          
        </nav>
        
        <slot></slot>  
      </div>
		</div>
</template>

<script>
import ImgKraudLogo from '@/assets/header/logo_kraud.svg'
import Group2 from '@/assets/header/Group2.png'
import transImg from '@/assets/profile/coins-rotate.png'
import assetsImg from '@/assets/profile/home-01.png'
import marketImg from '@/assets/profile/layers-03.png'
import referImg from '@/assets/profile/gift-01.png'
import walletImg from '@/assets/profile/wallet-01.png'
import taxesImg from '@/assets/profile/receipt-lines.png'
import settingsImg from '@/assets/profile/Icon.png'
import logoutImg from '@/assets/profile/logout-02.png'


export default {
  name: 'DefaultLayout',
  props: {
    validate: {
      type: String
    }
  },
  data () {
    return {
      transImg:transImg,
      logoutImg:logoutImg,
      settingsImg:settingsImg,
      taxesImg:taxesImg,
      walletImg:walletImg,
      referImg:referImg,
      marketImg:marketImg,
      assetsImg:assetsImg,
      ImgKraudLogo: ImgKraudLogo,
      Group2: Group2
    }
  },
  created () {
  }
  
}
</script>
